import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home/Home';
import WhatIsVector from '../learning/machine-learning/vector/WhatIsVector';
import WhatIsPoint from '../learning/machine-learning/point/WhatIsPoint';
import WhatIsMinimaMaxima from '../learning/machine-learning/gradient-descent/WhatIsMinimaMaxima';
import WhatIsGradientDescent from '../learning/machine-learning/gradient-descent/WhatIsGradientDescent';
import WhatIsGradientDescentWithMomentum from '../learning/machine-learning/gradient-descent/WhatIsGradientDescentWithMomentum';
import WhatIsStochasticGradientDescent from '../learning/machine-learning/gradient-descent/WhatIsStochasticGradientDescent';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/machine-learning/what-is-vector" element={<WhatIsVector />} />
      <Route path="/machine-learning/what-is-point" element={<WhatIsPoint />} />
      <Route path="/machine-learning/what-is-minima-maxima" element={<WhatIsMinimaMaxima />} />
      <Route
        path="/machine-learning/what-is-gradient-descent"
        element={<WhatIsGradientDescent />}
      />
      <Route
        path="/machine-learning/what-is-gradient-descent-with-momentum"
        element={<WhatIsGradientDescentWithMomentum />}
      />
      <Route
        path="/machine-learning/what-is-stochastic-gradient-descent"
        element={<WhatIsStochasticGradientDescent />}
      />
    </Routes>
  );
}

export default AppRoutes;
